import { createContext } from "react";

const initialState = {
  officer: {},
  selectedDate: "",
  plan: {},

  setSelectedDate: () => { },
  setPlan: () => { },
  setOfficer: () => { }
}

export default createContext(initialState);